import Severity from '@/shared/constants/Severity';
import { isPresent } from '@/shared/utils/typescript';
import Threshold from './Threshold';

export default class Measurement {
  constructor(public value: number | null = null, public severity: Severity | null = null) {}

  recalculateSeverity(threshold: Threshold, brakeDiscMinWidth?: number | null): void {
    if (!isPresent(this.value)) return;

    if (this.value <= threshold.bad + (brakeDiscMinWidth ?? 0)) {
      this.severity = Severity.BAD;
    } else if (this.value <= threshold.caution + (brakeDiscMinWidth ?? 0)) {
      this.severity = Severity.CAUTION;
    } else {
      this.severity = Severity.GOOD;
    }
  }

  static withData(data: Partial<Measurement>): Measurement {
    return Object.assign(new Measurement(), data);
  }
}
